export default __webpack_public_path__ + "static/media/accounting.df50b7c4.png";